import { FC } from 'react';
import { Avatar, Dropdown, MenuProps } from 'antd';
import { useTranslation } from 'react-i18next';
import { AiOutlineGlobal } from 'react-icons/ai';

const SwitchLanguage: FC = () => {
    const { t: l, i18n } = useTranslation('shared', { keyPrefix: 'LANGUAGES' });

    const changeLanguage = (locale: string) => {
        i18n.changeLanguage(locale);
    };

    const items: MenuProps['items'] = [
        {
            key: 'es',
            label: l('SPANISH'),
            onClick: () => changeLanguage('es'),
        },
        {
            key: 'en',
            label: l('ENGLISH'),
            onClick: () => changeLanguage('en'),
        },
    ];

    return (
        <Dropdown menu={{ items }} placement="bottomRight" trigger={['click']}>
            <Avatar
                size={28}
                src={<AiOutlineGlobal className="icon__inner" />}
                className="icon"
            />
        </Dropdown>
    );
};

export { SwitchLanguage };
